import { render, staticRenderFns } from "./RetailLayout.vue?vue&type=template&id=e36d49cc&scoped=true"
import script from "./RetailLayout.vue?vue&type=script&lang=js"
export * from "./RetailLayout.vue?vue&type=script&lang=js"
import style0 from "./RetailLayout.vue?vue&type=style&index=0&id=e36d49cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36d49cc",
  null
  
)

export default component.exports